import { TypeIcon } from '../../../icons';
import SlideoutMenu from '../../base/SlideoutMenu';

interface INameRowProps {
  name: string | null | undefined;
}

const NameRow = ({ name }: INameRowProps) => {
  if (!name) {
    return null;
  }

  return (
    <SlideoutMenu.Row icon={<TypeIcon className="size-4.5 shrink-0" />} title="Name">
      <div className="text-primary text-md min-w-0 truncate font-medium">{name}</div>
    </SlideoutMenu.Row>
  );
};

export default NameRow;
